import { Box } from "@mantine/core";

export default function Line({ color = "black", width = 1 }) {
  return (
    <Box
      className="liine"
      w={width}
      bg={color}
      style={{
        flex: 1,
      }}
    />
  );
}
